

module.exports = __webpack_require__.stylable.create(
    "WeeklyDesktopTodayBorder4179420866",
    {"classes":{"root":"WeeklyDesktopTodayBorder4179420866__root","TodayBorder":"WeeklyDesktopTodayBorder4179420866__TodayBorder"},"vars":{},"stVars":{"BorderWidth":"'\"unit(fallback(--cellBorderWidth, 1), px)\"'","BorderColor":"\"fallback(color(--todayCellColor), fallback(color(--borderColor), color(color-8)))\""},"keyframes":{}},
    "",
    1,
    "WeeklyDesktopTodayBorder4179420866",
    null
);
